import {useEffect} from 'react'
import {useTranslation} from 'react-i18next'
import {useQueries} from '@tanstack/react-query'
import {closeSnackbar, enqueueSnackbar} from 'notistack'
import {agencyKitQueryOptions, isKitGenerating} from '../../hooks/useAgencyKits.ts'
import {requestOpenAgencyKit, unwatchAgencyKit, useWatchedAgencyKitIds} from './kitWatch.ts'
import {kitDisplayStatus} from './kitDisplayStatus.ts'

// Mounted by DashboardPage (admins only): once the deck and PDF of a kit
// created in this session are done, tells the sales rep wherever they are in
// the portal, with a shortcut back to the kit.
export function useAgencyKitNotifier(openKitsSection: () => void) {
    const {t} = useTranslation('dashboard')
    const watchedIds = useWatchedAgencyKitIds()
    const results = useQueries({queries: watchedIds.map(id => agencyKitQueryOptions(id))})

    useEffect(() => {
        results.forEach(({data: kit}) => {
            if (!kit || isKitGenerating(kit)) return
            unwatchAgencyKit(kit.id)
            const isError = kitDisplayStatus(kit) === 'ERROR'
            enqueueSnackbar(t(isError ? 'agencyKits.notify.error' : 'agencyKits.notify.ready', {name: kit.agencyName}), {
                variant: isError ? 'error' : 'success',
                autoHideDuration: 10000,
                action: key => (
                    <button type="button"
                            onClick={() => { requestOpenAgencyKit(kit.id); openKitsSection(); closeSnackbar(key) }}
                            className="h-8 px-3 rounded-full bg-white/15 text-[13px] font-medium text-white transition-colors duration-200 ease-out hover:bg-white/25 focus-visible:outline focus-visible:outline-2 focus-visible:outline-white">
                        {t('agencyKits.notify.view')}
                    </button>
                ),
            })
        })
    }, [results, t, openKitsSection])
}
